import Vue from 'vue';
import Router from 'vue-router';
import Employes from '../views/Employes.vue';
import HorairesPerso from '../views/HorairesPerso.vue';
import HorairesGeneral from '../views/HorairesGeneral.vue';
import Heures from '../views/Heures.vue';
import Remplacements from '../views/Remplacements.vue';
import Help from '../views/Help.vue';
import NotFound from '../views/NotFound.vue';
import Login from '../views/Login.vue';
import Settings from '../views/Settings.vue';
import Particularites from '../views/Particularites.vue';
import Home from '../views/Home.vue';
import Vacances from '../views/Vacances.vue';
import About from '../views/About.vue';
import { requireAuth } from '../auth';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/employes',
      name: 'employes',
      component: Employes,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/perso',
      name: 'horaires_perso',
      component: HorairesPerso,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/general',
      name: 'horaires_general',
      component: HorairesGeneral,
      beforeEnter: requireAuth,
    },
    {
      path: '/heures',
      name: 'heures',
      component: Heures,
      beforeEnter: requireAuth,
    },
    {
      path: '/remplacements',
      name: 'remplacements',
      component: Remplacements,
      beforeEnter: requireAuth,
    },
    {
      path: '/aide',
      name: 'aide',
      component: Help,
      beforeEnter: requireAuth,
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/settings', 
      component: Settings, 
      name: 'Settings',
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/particularites', 
      component: Particularites, 
      name: 'Particularites',
      beforeEnter: requireAuth,
    },
    {
      path: '/vacances',
      component: Vacances,
      name: 'Vacances',
      beforeEnter: requireAuth,
    },
    {
      path: '/about',
      component: About,
      name: 'About',
      beforeEnter: requireAuth
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
      beforeEnter: requireAuth,
    }
  ]
})
